import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField, trailerNumber } from "helpers/validators";
import { selectList as cargoOwnersList } from "sources/books/cargoOwners";

const config = {
    counterpartyIds: {
        label: "Перевозчик(и)",
        inputProps: { name: "counterpartyIds" },
        url: cargoOwnersList,
        propName: "name",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
        components: { ValueContainer },
        ...defaultMultipleSelectProps,
    },
    number: {
        label: "Гос. номер",
        inputProps: { name: "number", placeholder: "АА 1111 / 777" },
        required: true,
        type: "trailerNumber",
        validators: [requiredField, trailerNumber],
    },
    typeId: {
        label: "Тип прицепа",
        inputProps: { name: "typeId" },
        dictionary: "trailerType",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    brandTypeId: {
        label: "Марка прицепа",
        inputProps: { name: "brandTypeId" },
        dictionary: "trailerBrandType",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
